module.exports = __webpack_public_path__ + "static/media/nike-there-will-be-goals.296810c2.mp4";